import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { ServerRequestProtected, ServerRequestPublic } from "../../../utils/ServerDataRequest";
import { enumUtil } from "../../../utils/Enum";
import NotificationHandler from "../../../utils/NotificationHandler";
import Loader from "../Loader/Loader";
import isNull from "../../../utils/NullChecking";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { formatFax } from "../../../utils/Formatting";
import FormatPhoneNumber from "../../../utils/FormatPhoneNumber";
import { useSelector } from "react-redux";
const MergeROIForm = ({ IsOpenROIForm, onClose, ID, PatientID }) => {
    const [isLoading, setIsLoading] = useState(false)
    const GENERAL_API_URL = enumUtil.controller.General
    const API_URL = enumUtil.controller.Patient
    const [Data, setData] = useState(null)
    useEffect(() => {
        setIsLoading(true)
        ServerRequestProtected(GENERAL_API_URL + "/FindByID", 'post', {
            "TableName": enumUtil.enumAPITableName.ReleaseOfInformationForm,
            "ID": ID
        }).then((response) => {
            setIsLoading(false)
            getSignaturePreview(response?.SignaturePath)
            setData(response)
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            setData(null)
        })
    }, [])
    const componentRef = useRef(null);
    const [imgFile, setImgFile] = useState(null)
    const API_URL_Wasabi = enumUtil.controller.Wasabi
    const getSignaturePreview = (SignaturePath) => {
        if (!isNull(SignaturePath)) {
            setImgFile(null);
            ServerRequestPublic(API_URL_Wasabi + "/DownloadFile",
                "post", { BucketPath: SignaturePath, }, "Download")
                .then((response) => {
                    if (response.type === "application/txt") {
                    } else if (["application/png", "application/jpg", "application/jpeg", "application/tiff"].includes(response.type)) {
                        const blob = response;
                        const objectURL = URL.createObjectURL(blob);
                        setImgFile(objectURL);
                    } else if (response.type === "application/pdf") {
                    } else {
                    }
                })
                .catch((error) => {
                    NotificationHandler("File Not Found", enumUtil.enumtoaster.error);
                });
        }
    }
    const captureDataAndGeneratePDF = async (type) => {
        setIsLoading(true);
        const element = componentRef.current;
        const originalOverflow = element.style.overflow;
        const originalBodyOverflow = document.body.style.overflow;

        try {
            // Adjust styles for capture
            element.style.overflow = 'visible';
            document.body.style.overflow = 'hidden';

            // Wait for layout to stabilize
            await new Promise(resolve => setTimeout(resolve, 300));

            // Capture the element
            const canvas = await html2canvas(element, {
                useCORS: true,
                scrollX: 0,
                scrollY: 0,
                scale: 2,
                width: element.scrollWidth,
                height: element.scrollHeight,
                logging: false,
                allowTaint: true
            });

            // Create PDF with custom dimensions
            const imgData = canvas.toDataURL('image/jpeg', 0.8);
            const imgWidth = 210; // A4 width in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            // Create PDF with calculated height (convert mm to pt)
            const pdf = new jsPDF({
                orientation: imgHeight > imgWidth ? 'p' : 'l',
                unit: 'mm',
                format: [imgWidth, imgHeight]
            });
            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
            if (type === "download") {
                pdf.save('IntakeForm.pdf');
            } else if (type === 'base64') {
                const pdfBase64 = pdf.output('datauristring');
                const formatedBase64 = pdfBase64.split(',')[1];
                return formatedBase64;
            }
        } catch (error) {
            console.error('Error generating PDF:', error);
        } finally {
            // Restore original styles
            element.style.overflow = originalOverflow;
            document.body.style.overflow = originalBodyOverflow;
            setIsLoading(false);
        }
    };
    const handleIntakeStatus = async (status, formID) => {
        let IntakeFormBase64 = await captureDataAndGeneratePDF('base64')
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/ChangeIntakeFormStatus", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientIntakeForm,
            "ID": ID,
            "Data": {
                IntakeStatus: "Processed",
                IntakeFormBase64: IntakeFormBase64,
                PatientID: PatientID,
                FileName: 'Release Of Information Form.pdf'
            }
        }).then((response) => {
            setIsLoading(false)
            NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
            onClose()
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response?.data, enumUtil.enumtoaster.error)
        })
    }
    const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <Modal show={IsOpenROIForm} onHide={IsOpenROIForm} backdrop="static" keyboard={false} centered dialogClassName="ar_merg-info-form-popup ar-merge-form-preview">
            {isLoading ? <Loader /> : null}
            <Modal.Body>
                <div className="ar_native_pdf_design pb-15" >
                    <div className="ar_print-header">
                        <div className="d-flex align-items-center justify-content-center gap-2 mb-12 pt-15 ar_print-header {">
                            <i className="icon-Icon-metro-cross fs-20" onClick={onClose}></i>
                        </div>
                        <div className="d-flex align-items-center justify-content-between pb-1-5 br-bottom-1 za_br_light px-10">
                            <p className="text fs-11 ar-light-color">Submitted on  {Data?.SubmittedDate || 'N/A'}</p>
                            <p className="text validate-color font-m cursor-pointer" onClick={handleIntakeStatus}>Mark As Processed </p>
                        </div>
                    </div>

                    <div className='d-flex flex-column gap-10' ref={componentRef}>
                        <div className='d-flex flex-column gap-10 px-10 pt-15 pb-15'>
                            <div className="d-flex align-items-center justify-content-center pat-det-header">
                                <p className="heading text-white">Release of Information</p>
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="">
                                    <img src={Data?.PracticeProfilePicture} alt="" style={{ maxHeight: '60px' }} crossOrigin="anonymous" />
                                </div>
                                <div className="text-center">
                                    <p className='heading validate-color fs-14'>{Data?.PracticeName || 'N/A'}</p>

                                    <p className="text text-black">{Data?.PracticeAddress || 'N/A'}</p>

                                </div>
                                <div className="d-flex gap-10">
                                    <div className="">
                                        <p className='text text-black font-m pb-2px'>Tel:</p>
                                        <p className='text text-black font-m'>Fax:</p>
                                    </div>
                                    <div className="">
                                        <p className='text text-black  pb-2px'>{FormatPhoneNumber(Data?.PracticeHomePhone)}</p>
                                        <p className='text text-black '>{formatFax(Data?.PracticeFax)}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="ar_star-form-Preview">
                                <div className="Form-content d-flex flex-column gap-10 p-0 h-100 overflow-visible">
                                    <div className="">
                                        <div className="pateint-information mb-10">
                                            <div className="d-flex align-items-center gap-1">
                                                <p className="heading fs-14 text-black min-w-85px">{Data?.Patient || 'N/A'}</p>
                                                <p className='text fs-13 text-black'>{Data?.DOB || 'N/A'}</p>
                                                <p className='text fs-13 text-black'>({Data?.Age || 'N/A'})</p>
                                                <p className='text fs-13 text-black'>{Data?.Gender || 'N/A'}</p>
                                            </div>
                                            <div className="d-flex align-items-center gap-1">
                                                <p className="heading fs-13 font-m text-black min-w-85px">Phone #</p>
                                                <p className='text fs-13 text-black'>{Data?.HomePhone || 'N/A'}</p>
                                            </div>
                                            <div className="d-flex align-items-center gap-1">
                                                <p className="heading fs-13 font-m text-black min-w-85px">Address:</p>
                                                <p className='text fs-13 text-black'>{Data?.PatientAddress || 'N/A'}</p>
                                            </div>
                                        </div>
                                        <p className="text text-black fs-13">I, authorize health care provider or practice mentioned in item 2 to use or disclose following information mentioned in item 5 to the above named patient:</p>
                                    </div>

                                    <div className="">
                                        <p className="heading text-black fs-14 mb-1">2. Healthcare Provider/Practice (Information Holder)</p>
                                        <p className='text text-black'>{Data?.PracticeName || 'N/A'}</p>
                                        <p className="text text-black"> <span className="font-m">Address:</span>
                                            {Data?.PracticeAddress || 'N/A'}
                                        </p>
                                    </div>

                                    <div className="">
                                        <p className="heading text-black fs-14 mb-1">3. Recipient (To Whom Information will be Shared)</p>
                                        <p className='text text-black'> {Data?.RecipientTo || 'N/A'}</p>
                                        <p className="text text-black"> <span className="font-m">Address:</span>
                                            {Data?.RecipientAddress || 'N/A'}
                                        </p>
                                    </div>

                                    <div className="">
                                        <p className="heading text-black fs-14 mb-1">4. Purpose of Disclosure</p>
                                        <p className='text text-black'>The information may be shared to support your care, treatment, or billing needs. It may also be used for legal, insurance, or personal purposes as requested.</p>
                                    </div>

                                    <div className="">
                                        <p className="heading text-black fs-14 mb-1">5. Information to be Released</p>
                                        <div className="custom_check_box d-flex gap-6 mb-1">
                                            {Data?.CompleteMedicalRecord ? <i className="icon-check fs-15 fw-900 mt-3px"></i> : null}
                                            <div className="">
                                                <p className="text fs-12 text-black user-select-none">Complete Medical Record, including:</p>
                                                <p className="text fs-12 text-black ar_dot">Patient Histories</p>
                                                <p className="text fs-12 text-black ar_dot">Lab Results</p>
                                                <p className="text fs-12 text-black ar_dot">Radiology Studies/FilmsReferrals</p>
                                                <p className="text fs-12 text-black ar_dot">Consults</p>
                                                <p className="text fs-12 text-black ar_dot">Patient Histories</p>
                                                <p className="text fs-12 text-black ar_dot">Billing RecordsInsurance Records</p>
                                                <p className="text fs-12 text-black ar_dot">Other</p>
                                            </div>
                                        </div>
                                        <div className="custom_check_box d-flex align-items-center gap-6">
                                            {Data?.AlcoholDrugTreatment ? <i className="icon-check fs-15 fw-900"></i> : 
                                            <i className="icon-alert fs-15"></i>
                                            }
                                            <p className="text fs-12 text-black user-select-none">Alcohol/Drug Treatment, Mental Health Information and HIV-Related Information.</p>
                                        </div>
                                    </div>

                                    <div className="">
                                        <p className="heading text-black fs-14 mb-1">6. Patient Rights/Authorization</p>
                                        <div className="d-flex flex-column gap-1 ps-2">
                                            <p className="text fs-12 text-black ar_dot">I may revoke this authorization at any time by contacting to the healthcare provider listed above.</p>
                                            <p className="text fs-12 text-black ar_dot">I understand that I cannot revoke this authorization for information that has already been released.</p>
                                            <p className="text fs-12 text-black ar_dot">Information disclosed under this authorization might be redisclosed by the recipient, and this redisclosure may no longer be protected by federal or state law.</p>
                                        </div>
                                    </div>

                                    <div className="">
                                        <p className="heading text-black fs-14 mb-1">7. Expiration/Revocation</p>

                                        <div className="">
                                            <p className="text fs-12 text-black">This authorization will remain in effect until it is revoked by contacting the practice.</p>
                                            <p className="text fs-12 text-black ar_dot ps-2">
                                                I understand that I can revoke this authorization at any time prior to that date. Revocation will not apply to information that has already been released based on this authorization.</p>
                                        </div>
                                    </div>

                                    <div className="">
                                        <p className="heading text-black fs-14 mb-1">8. Signature Authorization</p>

                                        <div className="d-flex flex-column gap-5">
                                            <p className="text fs-12 text-black">I consent that my electronic signature below has the same legal effect as a handwritten signature for purposes of validity.</p>
                                            <div className="content-box">
                                                <div className="d-flex align-items-center gap-15">
                                                    <p className='text fs-14 text-black min-w-156px text-end ar-light-color'>Signature</p>
                                                    <div className="d-flex align-items-center gap-15 sign-content justify-content-center">
                                                        <img
                                                            src={imgFile}
                                                            style={{ maxHeight: "60px" }}
                                                            alt="Uploaded preview"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="text-center pt-1-5 br-top-1 za_br_light print-footer mt-5">
                            <p className="text ar-light-color">By {ThemeConfiguration?.configuration?.company?.name}
                                (<a href="https://starhealthcare.co" className="ar-hover-text ar-light-color text" target="_blank" rel="noopener noreferrer">https://starhealthcare.co</a>) </p>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default MergeROIForm